<template>
    <section id="grace-period">
        <h3 class="text-uppercase mt-4">Subscription and billing</h3>
        <hr class="bar my-3" />

        <div>
            <p class="font-weight-bold text-danger">
                Your subscription has been cancelled and will expire on
                {{ moment(subscription.renews_at).format("MM/DD/YYYY") }}.
            </p>
            <p class="font-weight-bold mb-0">Subscription plan: {{ subscription.plan }}</p>
            <p class="font-weight-bold">Seats: {{ subscription.quantity }}</p>
        </div>

        <div class="d-flex w-100 justify-content-between align-items-start my-4">
            <button
                id="pre-resume"
                class="btn btn-link font-weight-bold text-uppercase text-primary"
                @click="showResumeSubscriptionModal()"
            >
                Resume Subscription
            </button>
        </div>

        <modal
            id="resume-modal"
            :visible="isVisible"
            title="Resume subscription"
            @close="resetModal()"
        >
            <!--RESUME SUBSCRIPTION-->
            <div>
                <p class="text-center">Are you sure you want to resume your subscription?</p>
                <div class="d-flex w-100 justify-content-between align-items-center py-3">
                    <button
                        class="small btn btn-sm btn-link text-primary font-weight-bold text-uppercase"
                        @click.prevent="resetModal()"
                    >
                        No, don't resume
                    </button>
                    <button
                        id="resume"
                        class="btn btn-sm btn-primary font-weight-bold text-uppercase text-white"
                        @click.prevent="resumeSubscription()"
                    >
                        Yes, resume subscription
                    </button>
                </div>
            </div>
        </modal>
    </section>
</template>

<script>
import { helpers } from "../../plugins/helpers";
import Modal from "../ui/ModalComponent";

export default {
    name: "AccountGracePeriod",
    props: ["user", "subscription"],
    components: { Modal },
    data() {
        return {
            isVisible: false,
        };
    },
    methods: {
        showResumeSubscriptionModal() {
            this.isVisible = true;
        },

        resumeSubscription() {
            helpers.toggleSpinner("resume");
            axios
                .post(`/api/users/${this.user.id}/subscription/resume`)
                .then(r => {
                    helpers.toggleSpinner("resume");
                    window.location.href = "/account-settings";
                    this.$swal("Done!", `Your account was successfully updated.`, "success");
                    this.resetModal();
                })
                .catch(e => {
                    helpers.toggleSpinner("resume");
                    console.error(e);
                });
        },

        resetModal() {
            this.isVisible = false;
        },
    },
};
</script>

<style scoped></style>
